(function () {
  // Initialize from Data Attributes
  const container = document.querySelector('[data-lp-form-section]');
  if (!container) {
    console.warn('LP Chat Form Section not found.');
    return;
  }

  const STOREFRONT_ACCESS_TOKEN = container.dataset.token;
  if (!STOREFRONT_ACCESS_TOKEN) {
    console.error('Storefront Access Token is missing.');
  }

  // ★ reCAPTCHA サイトキー within namespace if needed
  const RECAPTCHA_SITE_KEY = '6LdG1gcsAAAAABKLuAqP_UQY8S036TmBh1cUKrnW';

  const productData = {
    "bra_relax": {
      "key": "bra_relax",
      "code": "pgbsp100",
      "name": "PGブラ（リラックス）",
      "size_color": {
        "XS": { "BK": "ブラック", "B": "カーキ" },
        "S": { "BK": "ブラック", "B": "カーキ" },
        "M": { "BK": "ブラック", "B": "カーキ" },
        "L": { "BK": "ブラック", "B": "カーキ" },
        "LL": { "BK": "ブラック", "B": "カーキ(完売)" },
        "3L": { "BK": "ブラック", "B": "カーキ(完売)" }
      }
    },
    "pgbra_nonwire": {
      "key": "pgbra_nonwire",
      "code": "pgbnw100",
      "name": "PGブラ(ノンワイヤー)",
      "size_color": {
        "XS": { "B": "ブラック(完売)", "W": "ホワイト(完売)", "P": "ピンク(完売)", "N": "ネイビー(完売)" },
        "S": { "B": "ブラック", "W": "ホワイト", "P": "ピンク", "N": "ネイビー" },
        "M": { "B": "ブラック(完売)", "W": "ホワイト", "P": "ピンク", "N": "ネイビー(完売)" },
        "L": { "B": "ブラック(完売)", "W": "ホワイト", "P": "ピンク", "N": "ネイビー" },
        "LL": { "B": "ブラック", "W": "ホワイト", "P": "ピンク", "N": "ネイビー" },
        "3L": { "B": "ブラック", "W": "ホワイト", "P": "ピンク", "N": "ネイビー" }
      }
    }
  };

  const productTypeNames = {
    'bra_relax': 'PGブラ（リラックス）',
    'pgbra_nonwire': 'PGブラ(ノンワイヤー)'
  };

  const productCodes = {
    'bra_relax': 'pgbsp100',
    'pgbra_nonwire': 'pgbnw100'
  };

  let client, cart;
  let isRestoring = false;
  let saveTimer;

  const loginModal = document.getElementById('loginModal');
  const openLoginBtn = document.getElementById('openLoginBtn');
  const closeLoginBtn = document.getElementById('closeLoginBtn');
  const loginForm = document.getElementById('loginForm');
  const loginError = document.getElementById('loginError');
  const loginLoading = document.getElementById('loginLoading');
  const loginSubmitBtn = document.getElementById('loginSubmitBtn');

  if (openLoginBtn) {
    openLoginBtn.addEventListener('click', function () {
      loginModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeModal() {
    loginModal.classList.remove('active');
    document.body.style.overflow = '';
    loginError.classList.remove('active');
    loginForm.reset();
  }

  if (closeLoginBtn) {
    closeLoginBtn.addEventListener('click', closeModal);
  }

  if (loginModal) {
    loginModal.addEventListener('click', function (e) {
      if (e.target === loginModal) {
        closeModal();
      }
    });
  }

  if (loginForm) {
    loginForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const email = document.getElementById('loginEmail').value;
      const password = document.getElementById('loginPassword').value;

      loginError.classList.remove('active');
      loginLoading.classList.add('active');
      loginSubmitBtn.disabled = true;

      const mutation = `
        mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
          customerAccessTokenCreate(input: $input) {
            customerAccessToken {
              accessToken
              expiresAt
            }
            customerUserErrors {
              code
              field
              message
            }
          }
        }
      `;

      fetch('https://p-grandi.myshopify.com/api/2025-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify({
          query: mutation,
          variables: {
            input: {
              email: email,
              password: password
            }
          }
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.data.customerAccessTokenCreate.customerUserErrors.length > 0) {
            throw new Error(data.data.customerAccessTokenCreate.customerUserErrors[0].message);
          }

          const accessToken = data.data.customerAccessTokenCreate.customerAccessToken.accessToken;

          const customerQuery = `
          query getCustomer($customerAccessToken: String!) {
            customer(customerAccessToken: $customerAccessToken) {
              id
              firstName
              lastName
              email
              phone
              defaultAddress {
                address1
                address2
                city
                province
                zip
              }
            }
          }
        `;

          return fetch('https://p-grandi.myshopify.com/api/2025-07/graphql.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
            },
            body: JSON.stringify({
              query: customerQuery,
              variables: {
                customerAccessToken: accessToken
              }
            })
          });
        })
        .then(response => response.json())
        .then(data => {
          const customer = data.data.customer;

          if (!customer) {
            throw new Error('顧客情報の取得に失敗しました');
          }

          document.getElementById('last_name').value = customer.lastName || '';
          document.getElementById('first_name').value = customer.firstName || '';
          document.getElementById('customer_email').value = customer.email || '';

          if (customer.phone) {
            // ★ 国際形式（+81）を日本国内形式（0）に変換
            let phone = customer.phone.replace(/\D/g, ''); // 数字のみ抽出
            if (phone.startsWith('81')) {
              phone = '0' + phone.substring(2); // +81 → 0 に置き換え
            }
            document.getElementById('customer_phone').value = phone;
            const phoneEvent = new Event('input', { bubbles: true });
            document.getElementById('customer_phone').dispatchEvent(phoneEvent);
          }

          if (customer.defaultAddress) {
            const addr = customer.defaultAddress;

            if (addr.zip) {
              const zip = addr.zip.replace(/-/g, '');
              document.getElementById('customer_zip').value = zip;
              const zipEvent = new Event('input', { bubbles: true });
              document.getElementById('customer_zip').dispatchEvent(zipEvent);
            }

            if (addr.province) {
              document.getElementById('customer_province').value = addr.province;
            }

            if (addr.city) {
              document.getElementById('customer_city').value = addr.city;
            }

            if (addr.address1) {
              document.getElementById('customer_address1').value = addr.address1;
            }

            if (addr.address2) {
              document.getElementById('customer_address2').value = addr.address2;
            }
          }

          saveFormState();
          closeModal();

          showError('✅ ログイン成功！お客様情報を自動入力しました', false);
          setTimeout(function () {
            document.getElementById('errorMessage').classList.remove('active');
          }, 3000);
        })
        .catch(error => {
          loginError.textContent = 'ログインに失敗しました。メールアドレスとパスワードを確認してください。';
          loginError.classList.add('active');
        })
        .finally(function () {
          loginLoading.classList.remove('active');
          loginSubmitBtn.disabled = false;
        });
    });
  }

  function initShopify() {
    client = ShopifyBuy.buildClient({
      domain: 'p-grandi.myshopify.com',
      storefrontAccessToken: STOREFRONT_ACCESS_TOKEN
    });

    client.checkout.create().then(function (checkout) {
      cart = checkout;
    }).catch(function (error) {
      showError('Shopifyとの接続に失敗しました。', false);
    });
  }

  function showError(message, scroll) {
    const errorEl = document.getElementById('errorMessage');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.classList.add('active');
      if (scroll) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      setTimeout(function () {
        errorEl.classList.remove('active');
      }, 5000);
    }
  }

  if (window.ShopifyBuy && window.ShopifyBuy.buildClient) {
    initShopify();
  } else {
    const checkShopify = setInterval(function () {
      if (window.ShopifyBuy && window.ShopifyBuy.buildClient) {
        clearInterval(checkShopify);
        initShopify();
      }
    }, 100);
  }

  const form = document.getElementById('customOrderForm');
  const setTypeSelect = document.getElementById('set_type');
  const productSelectionsContainer = document.getElementById('product_selections');
  const submitBtn = document.getElementById('submitBtn');
  const loadingEl = document.getElementById('loading');
  const agreementCheckbox = document.getElementById('agreement');
  const zipInput = document.getElementById('customer_zip');
  const zipLoading = document.getElementById('zipLoading');
  const provinceSelect = document.getElementById('customer_province');
  const cityInput = document.getElementById('customer_city');
  const phoneInput = document.getElementById('customer_phone');

  function resetLoadingState() {
    loadingEl.classList.remove('active');
    if (agreementCheckbox.checked) {
      submitBtn.disabled = false;
    }
  }

  function saveFormState() {
    if (isRestoring) return;

    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      const formData = {
        set_type: setTypeSelect.value,
        last_name: document.getElementById('last_name').value,
        first_name: document.getElementById('first_name').value,
        customer_email: document.getElementById('customer_email').value,
        customer_phone: document.getElementById('customer_phone').value,
        customer_zip: document.getElementById('customer_zip').value,
        customer_province: document.getElementById('customer_province').value,
        customer_city: document.getElementById('customer_city').value,
        customer_address1: document.getElementById('customer_address1').value,
        customer_address2: document.getElementById('customer_address2').value,
        agreement: agreementCheckbox.checked
      };

      const selectedSetOption = setTypeSelect.options[setTypeSelect.selectedIndex];
      if (selectedSetOption.value) {
        const items = JSON.parse(selectedSetOption.dataset.items);
        formData.products = {};

        items.forEach(item => {
          const productType = item.type;
          const count = item.count;

          for (let i = 1; i <= count; i++) {
            const sizeSelect = document.getElementById(`${productType}_size_${i}`);
            const colorSelect = document.getElementById(`${productType}_color_${i}`);

            if (sizeSelect && colorSelect) {
              formData.products[`${productType}_size_${i}`] = sizeSelect.value;
              formData.products[`${productType}_color_${i}`] = colorSelect.value;
            }
          }
        });
      }

      sessionStorage.setItem('orderFormData', JSON.stringify(formData));
    }, 500);
  }

  function restoreFormState() {
    const savedData = sessionStorage.getItem('orderFormData');
    if (!savedData) return;

    try {
      isRestoring = true;

      const formData = JSON.parse(savedData);

      if (formData.last_name) document.getElementById('last_name').value = formData.last_name;
      if (formData.first_name) document.getElementById('first_name').value = formData.first_name;
      if (formData.customer_email) document.getElementById('customer_email').value = formData.customer_email;
      if (formData.customer_phone) document.getElementById('customer_phone').value = formData.customer_phone;
      if (formData.customer_zip) document.getElementById('customer_zip').value = formData.customer_zip;
      if (formData.customer_province) document.getElementById('customer_province').value = formData.customer_province;
      if (formData.customer_city) document.getElementById('customer_city').value = formData.customer_city;
      if (formData.customer_address1) document.getElementById('customer_address1').value = formData.customer_address1;
      if (formData.customer_address2) document.getElementById('customer_address2').value = formData.customer_address2;

      if (formData.agreement) {
        agreementCheckbox.checked = true;
        submitBtn.disabled = false;
      }

      if (formData.set_type) {
        setTypeSelect.value = formData.set_type;

        const changeEvent = new Event('change', { bubbles: true });
        setTypeSelect.dispatchEvent(changeEvent);

        setTimeout(function () {
          if (formData.products) {
            Object.keys(formData.products).forEach(key => {
              const element = document.getElementById(key);
              if (element) {
                element.value = formData.products[key];

                if (key.includes('_size_')) {
                  const changeEvent = new Event('change', { bubbles: true });
                  element.dispatchEvent(changeEvent);

                  setTimeout(function () {
                    const colorKey = key.replace('_size_', '_color_');
                    const colorElement = document.getElementById(colorKey);
                    if (colorElement && formData.products[colorKey]) {
                      colorElement.value = formData.products[colorKey];
                    }
                  }, 100);
                }
              }
            });
          }

          isRestoring = false;
        }, 200);
      } else {
        isRestoring = false;
      }
    } catch (error) {
      isRestoring = false;
    }
  }

  window.addEventListener('load', function () {
    restoreFormState();
    resetLoadingState();
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      restoreFormState();
      resetLoadingState();
    }
  });

  if (form) {
    form.addEventListener('input', function (e) {
      if (!isRestoring) {
        saveFormState();
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!cart) {
        showError('カートの準備中です。少々お待ちください。', true);
        return;
      }

      if (!agreementCheckbox.checked) {
        showError('規約への同意が必要です', true);
        return;
      }

      const selectedSetOption = setTypeSelect.options[setTypeSelect.selectedIndex];
      if (!selectedSetOption.value) {
        showError('セット内容を選択してください', true);
        return;
      }

      const items = JSON.parse(selectedSetOption.dataset.items);
      let firstErrorElement = null;

      // 商品のバリデーション
      items.forEach(item => {
        const productType = item.type;
        const count = item.count;

        for (let i = 1; i <= count; i++) {
          const sizeSelect = document.getElementById(`${productType}_size_${i}`);
          const colorSelect = document.getElementById(`${productType}_color_${i}`);

          // サイズ未選択
          if (sizeSelect && !sizeSelect.value) {
            sizeSelect.classList.add('validation-error');
            if (!firstErrorElement) firstErrorElement = sizeSelect;
          } else if (sizeSelect) {
            sizeSelect.classList.remove('validation-error');
          }

          // カラー未選択
          if (colorSelect && !colorSelect.value) {
            colorSelect.classList.add('validation-error');
            if (!firstErrorElement) firstErrorElement = colorSelect;
          } else if (colorSelect) {
            colorSelect.classList.remove('validation-error');
          }
        }
      });

      // 4枚セットの特典バリデーション
      const hasSpecialGift = selectedSetOption.dataset.hasSpecialGift === 'true';
      if (hasSpecialGift) {
        const giftType = document.querySelector('input[name="special_gift"]:checked');

        if (!giftType) {
          // 特典が選択されていない
          const giftSection = document.getElementById('special_gift_section');
          if (giftSection) {
            giftSection.style.border = '3px solid #f44336';
            if (!firstErrorElement) firstErrorElement = giftSection;
          }
        } else {
          const giftSection = document.getElementById('special_gift_section');
          if (giftSection) {
            giftSection.style.border = '2px solid #ff9800';
          }

          // PGブラノンワイヤーの場合、サイズ・カラーチェック
          if (giftType.value === 'pgbra_nonwire') {
            const giftSize = document.getElementById('gift_pgbra_size');
            const giftColor = document.getElementById('gift_pgbra_color');

            if (giftSize && !giftSize.value) {
              giftSize.classList.add('validation-error');
              if (!firstErrorElement) firstErrorElement = giftSize;
            } else if (giftSize) {
              giftSize.classList.remove('validation-error');
            }

            if (giftColor && !giftColor.value) {
              giftColor.classList.add('validation-error');
              if (!firstErrorElement) firstErrorElement = giftColor;
            } else if (giftColor) {
              giftColor.classList.remove('validation-error');
            }
          }
        }
      }

      // エラーがある場合
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        showError('未選択の項目があります。赤く表示されている箇所を選択してください。', false);
        return;
      }

      submitBtn.disabled = true;
      loadingEl.classList.add('active');

      processOrder();
    });
  }

  if (setTypeSelect) {
    setTypeSelect.addEventListener('change', function () {
      if (isRestoring) return;

      const selectedOption = this.options[this.selectedIndex];

      if (!selectedOption.value) {
        productSelectionsContainer.style.display = 'none';
        productSelectionsContainer.innerHTML = '';
        return;
      }

      try {
        const items = JSON.parse(selectedOption.dataset.items);
        generateProductSelections(items);
        productSelectionsContainer.style.display = 'block';

        const specialGiftSection = document.getElementById('special_gift_section');
        const hasSpecialGift = selectedOption.dataset.hasSpecialGift === 'true';

        if (hasSpecialGift && specialGiftSection) {
          specialGiftSection.style.display = 'block';
          setupGiftSelection();
        } else if (specialGiftSection) {
          specialGiftSection.style.display = 'none';
          const giftPgbraNonwireSelection = document.getElementById('gift_pgbra_nonwire_selection');
          if (giftPgbraNonwireSelection) {
            giftPgbraNonwireSelection.classList.remove('active');
          }
        }
        saveFormState();
      } catch (error) {
        showError('商品選択に失敗しました。', false);
      }
    });
  }

  function generateProductSelections(items) {
    productSelectionsContainer.innerHTML = '';

    items.forEach(item => {
      const productType = item.type;
      const count = item.count;
      const productName = productTypeNames[productType];

      let productInfo = null;
      for (let key in productData) {
        if (productData[key].key === productType) {
          productInfo = productData[key];
          break;
        }
      }

      if (!productInfo) return;

      const productContainer = document.createElement('div');
      productContainer.style.marginBottom = '20px';

      const title = document.createElement('h4');
      title.textContent = productName;
      title.style.fontSize = '18px';
      title.style.fontWeight = 'bold';
      title.style.marginBottom = '15px';
      title.style.color = '#333';
      productContainer.appendChild(title);

      for (let i = 1; i <= count; i++) {
        const itemDiv = document.createElement('div');
        itemDiv.className = 'product-item';

        const itemTitle = document.createElement('div');
        itemTitle.innerHTML = `<span class="product-item-number">${i}枚目</span>`;
        itemDiv.appendChild(itemTitle);

        const sizeColorRow = document.createElement('div');
        sizeColorRow.className = 'size-color-row';

        const sizeGroup = document.createElement('div');
        const sizeLabel = document.createElement('label');
        sizeLabel.textContent = 'サイズ';
        sizeLabel.style.fontWeight = 'bold';
        sizeLabel.style.marginBottom = '5px';
        sizeLabel.style.display = 'block';

        const sizeSelect = document.createElement('select');
        sizeSelect.id = `${productType}_size_${i}`;
        sizeSelect.name = `${productType}_size_${i}`;
        sizeSelect.required = true;
        sizeSelect.style.width = '100%';
        sizeSelect.style.padding = '10px';
        sizeSelect.style.border = '1px solid #ddd';
        sizeSelect.style.borderRadius = '5px';

        const sizeDefaultOption = document.createElement('option');
        sizeDefaultOption.value = '';
        sizeDefaultOption.textContent = 'サイズを選択';
        sizeSelect.appendChild(sizeDefaultOption);

        Object.keys(productInfo.size_color).forEach(size => {
          const option = document.createElement('option');
          option.value = size;
          option.textContent = size;
          sizeSelect.appendChild(option);
        });

        sizeGroup.appendChild(sizeLabel);
        sizeGroup.appendChild(sizeSelect);

        const colorGroup = document.createElement('div');
        const colorLabel = document.createElement('label');
        colorLabel.textContent = 'カラー';
        colorLabel.style.fontWeight = 'bold';
        colorLabel.style.marginBottom = '5px';
        colorLabel.style.display = 'block';

        const colorSelect = document.createElement('select');
        colorSelect.id = `${productType}_color_${i}`;
        colorSelect.name = `${productType}_color_${i}`;
        colorSelect.required = true;
        colorSelect.disabled = true;
        colorSelect.style.width = '100%';
        colorSelect.style.padding = '10px';
        colorSelect.style.border = '1px solid #ddd';
        colorSelect.style.borderRadius = '5px';

        const colorDefaultOption = document.createElement('option');
        colorDefaultOption.value = '';
        colorDefaultOption.textContent = '先にサイズを選択してください';
        colorSelect.appendChild(colorDefaultOption);

        colorGroup.appendChild(colorLabel);
        colorGroup.appendChild(colorSelect);

        sizeColorRow.appendChild(sizeGroup);
        sizeColorRow.appendChild(colorGroup);
        itemDiv.appendChild(sizeColorRow);

        productContainer.appendChild(itemDiv);

        sizeSelect.addEventListener('change', function () {
          if (!isRestoring) {
            updateColorOptions(this.value, colorSelect, productInfo);
            saveFormState();
          }
        });

        colorSelect.addEventListener('change', function () {
          if (!isRestoring) {
            saveFormState();
          }
        });
      }

      productSelectionsContainer.appendChild(productContainer);
    });
  }

  function updateColorOptions(selectedSize, colorSelect, productInfo) {
    colorSelect.innerHTML = '';

    if (!selectedSize) {
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = '先にサイズを選択してください';
      colorSelect.appendChild(defaultOption);
      colorSelect.disabled = true;
      return;
    }

    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'カラーを選択';
    colorSelect.appendChild(defaultOption);

    const colors = productInfo.size_color[selectedSize];
    if (colors) {
      Object.keys(colors).forEach(colorCode => {
        const colorName = colors[colorCode];
        const option = document.createElement('option');
        option.value = colorCode;
        option.textContent = colorName;

        if (colorName.includes('完売')) {
          option.disabled = true;
        }

        colorSelect.appendChild(option);
      });
    }

    colorSelect.disabled = false;
  }

  function setupGiftSelection() {
    const glamorousOption = document.getElementById('gift_glamorous');
    const pgbraOption = document.getElementById('gift_pgbra_nonwire');
    const pgbraSelection = document.getElementById('gift_pgbra_nonwire_selection');
    const giftSizeSelect = document.getElementById('gift_pgbra_size');
    const giftColorSelect = document.getElementById('gift_pgbra_color');

    if (!glamorousOption || !pgbraOption || !pgbraSelection) return;

    const glamorousRadio = document.getElementById('special_gift_glamorous');
    const pgbraRadio = document.getElementById('special_gift_pgbra_nonwire');

    glamorousOption.onclick = function () {
      if (glamorousRadio) glamorousRadio.checked = true;
      glamorousOption.classList.add('selected');
      pgbraOption.classList.remove('selected');
      pgbraSelection.classList.remove('active');
      if (!isRestoring) saveFormState();
    };

    pgbraOption.onclick = function () {
      if (pgbraRadio) pgbraRadio.checked = true;
      pgbraOption.classList.add('selected');
      glamorousOption.classList.remove('selected');
      pgbraSelection.classList.add('active');
      if (!isRestoring) saveFormState();
    };

    if (giftSizeSelect) {
      giftSizeSelect.addEventListener('change', function () {
        if (!isRestoring) {
          updateGiftColorOptions(this.value, giftColorSelect);
          saveFormState();
        }
      });
    }

    if (giftColorSelect) {
      giftColorSelect.addEventListener('change', function () {
        if (!isRestoring) {
          saveFormState();
        }
      });
    }
  }

  function updateGiftColorOptions(selectedSize, colorSelect) {
    if (!colorSelect) return;

    colorSelect.innerHTML = '';

    if (!selectedSize) {
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = '先にサイズを選択してください';
      colorSelect.appendChild(defaultOption);
      colorSelect.disabled = true;
      return;
    }

    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'カラーを選択';
    colorSelect.appendChild(defaultOption);

    const pgbraInfo = productData['pgbra_nonwire'];
    if (pgbraInfo && pgbraInfo.size_color[selectedSize]) {
      const colors = pgbraInfo.size_color[selectedSize];
      Object.keys(colors).forEach(colorCode => {
        const colorName = colors[colorCode];
        const option = document.createElement('option');
        option.value = colorCode;
        option.textContent = colorName;

        if (colorName.includes('完売')) {
          option.disabled = true;
        }

        colorSelect.appendChild(option);
      });
    }

    colorSelect.disabled = false;
  }

  if (agreementCheckbox) {
    agreementCheckbox.addEventListener('change', function () {
      submitBtn.disabled = !this.checked;
      if (!isRestoring) {
        saveFormState();
      }
    });
  }

  const agreementWrapper = document.getElementById('agreementCheckboxWrapper');
  if (agreementWrapper) {
    agreementWrapper.addEventListener('click', function (e) {
      if (e.target !== agreementCheckbox && e.target.tagName !== 'A' && e.target.tagName !== 'LABEL') {
        agreementCheckbox.checked = !agreementCheckbox.checked;
        submitBtn.disabled = !agreementCheckbox.checked;
        if (!isRestoring) {
          saveFormState();
        }
      }
    });
  }

  let zipTimer;
  if (zipInput) {
    zipInput.addEventListener('input', function (e) {
      let value = e.target.value.replace(/[^0-9]/g, '');

      if (value.length > 3) {
        value = value.slice(0, 3) + '-' + value.slice(3, 7);
      }
      e.target.value = value;

      const zipCode = value.replace('-', '');
      if (zipCode.length === 7) {
        clearTimeout(zipTimer);
        zipTimer = setTimeout(function () {
          searchAddress(zipCode);
        }, 500);
      }
    });
  }

  function searchAddress(zipCode) {
    zipLoading.style.display = 'block';

    fetch('https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + zipCode)
      .then(response => response.json())
      .then(data => {
        zipLoading.style.display = 'none';

        if (data.results && data.results.length > 0) {
          const result = data.results[0];
          provinceSelect.value = result.address1;
          cityInput.value = result.address2 + result.address3;
          if (!isRestoring) {
            saveFormState();
          }
        } else {
          showError('郵便番号から住所が見つかりませんでした。', false);
        }
      })
      .catch(function (error) {
        zipLoading.style.display = 'none';
      });
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', function (e) {
      let value = e.target.value.replace(/[^0-9]/g, '');

      if (value.length > 11) {
        value = value.slice(0, 11);
      }

      let formatted = '';

      if (value.length === 0) {
        formatted = '';
      } else if (value.startsWith('0120') || value.startsWith('0800')) {
        if (value.length <= 4) {
          formatted = value;
        } else if (value.length <= 7) {
          formatted = value.slice(0, 4) + '-' + value.slice(4);
        } else {
          formatted = value.slice(0, 4) + '-' + value.slice(4, 7) + '-' + value.slice(7);
        }
      } else if (value.startsWith('050')) {
        if (value.length <= 3) {
          formatted = value;
        } else if (value.length <= 7) {
          formatted = value.slice(0, 3) + '-' + value.slice(3);
        } else {
          formatted = value.slice(0, 3) + '-' + value.slice(3, 7) + '-' + value.slice(7);
        }
      } else if (value.match(/^0[789]0/)) {
        if (value.length <= 3) {
          formatted = value;
        } else if (value.length <= 7) {
          formatted = value.slice(0, 3) + '-' + value.slice(3);
        } else {
          formatted = value.slice(0, 3) + '-' + value.slice(3, 7) + '-' + value.slice(7);
        }
      } else if (value.match(/^0[1-9]/)) {
        if (value.length <= 2) {
          formatted = value;
        } else if (value.length <= 6) {
          formatted = value.slice(0, 2) + '-' + value.slice(2);
        } else {
          formatted = value.slice(0, 2) + '-' + value.slice(2, 6) + '-' + value.slice(6, 10);
        }
      } else {
        formatted = value;
      }

      e.target.value = formatted;
    });
  }

  function generateOrderDetails() {
    let details = "**************************************************\n";
    details += "  注文明細\n";
    details += "**************************************************\n";

    const selectedOption = setTypeSelect.options[setTypeSelect.selectedIndex];
    const items = JSON.parse(selectedOption.dataset.items);

    const productCounts = {};

    items.forEach(item => {
      const productType = item.type;
      const count = item.count;
      const productName = productTypeNames[productType];
      const productCode = productCodes[productType];

      for (let i = 1; i <= count; i++) {
        const sizeSelect = document.getElementById(`${productType}_size_${i}`);
        const colorSelect = document.getElementById(`${productType}_color_${i}`);

        if (sizeSelect && colorSelect) {
          const size = sizeSelect.value;
          const colorCode = colorSelect.value;
          const colorText = colorSelect.options[colorSelect.selectedIndex].text;
          const sku = productCode + size.toLowerCase() + colorCode.toLowerCase();

          const key = sku;

          if (!productCounts[key]) {
            productCounts[key] = {
              productName: productName,
              sku: sku,
              colorText: colorText,
              size: size,
              count: 0
            };
          }
          productCounts[key].count++;
        }
      }
    });

    Object.keys(productCounts).forEach(key => {
      const item = productCounts[key];
      details += `[明細]:${item.productName}:${item.sku}:カラー:${item.colorText}:サイズ:${item.size}:${item.count}枚_\n`;
    });

    // ★ セット特典の追加
    const setType = selectedOption.value;

    // サプリの追加
    if (setType === 'relax_2set') {
      details += `[明細]:脂肪燃焼サプリ:mr001:1つ_\n`;
    } else if (setType === 'relax_4set') {
      details += `[明細]:脂肪燃焼サプリ:mr001:2つ_\n`;
    }

    // 4枚セットの特典
    if (setType === 'relax_4set') {
      const giftType = document.querySelector('input[name="special_gift"]:checked');

      if (giftType && giftType.value === 'pgbra_nonwire') {
        const giftSize = document.getElementById('gift_pgbra_size');
        const giftColor = document.getElementById('gift_pgbra_color');

        if (giftSize && giftColor && giftSize.value && giftColor.value) {
          const size = giftSize.value;
          const colorCode = giftColor.value;
          const colorText = giftColor.options[giftColor.selectedIndex].text;
          const sku = 'pgbnw100' + size.toLowerCase() + colorCode.toLowerCase();

          details += `[明細]:PGブラ（ノンワイヤー）:${sku}:カラー:${colorText}:サイズ:${size}:1枚_\n`;
        }
      } else if (giftType && giftType.value === 'glamorous') {
        details += `[明細]:グラマラス美神:glamorous_bijin:1つ_\n`;
      }
    }

    details += "**************************************************\n";

    return details;
  }

  function executeRecaptcha() {
    return new Promise(function (resolve, reject) {
      if (typeof grecaptcha === 'undefined') {
        reject(new Error('reCAPTCHA が読み込まれていません'));
        return;
      }

      grecaptcha.ready(function () {
        grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' })
          .then(function (token) {
            resolve(token);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    });
  }

  function processOrder() {
    const lastName = document.getElementById('last_name').value;
    const firstName = document.getElementById('first_name').value;
    const email = document.getElementById('customer_email').value;
    const phone = document.getElementById('customer_phone').value;
    const zip = document.getElementById('customer_zip').value.replace('-', '');
    const province = document.getElementById('customer_province').value;
    const city = document.getElementById('customer_city').value;
    const address1 = document.getElementById('customer_address1').value;
    const address2 = document.getElementById('customer_address2').value;

    const selectedSetOption = setTypeSelect.options[setTypeSelect.selectedIndex];
    const variantId = selectedSetOption.dataset.variantId;

    if (!variantId) {
      showError('商品情報の取得に失敗しました', true);
      submitBtn.disabled = false;
      loadingEl.classList.remove('active');
      return Promise.reject();
    }

    const items = JSON.parse(selectedSetOption.dataset.items);
    const customAttributes = [];
    const productCounts = {};

    items.forEach(item => {
      const productType = item.type;
      const count = item.count;
      const productName = productTypeNames[productType];

      for (let i = 1; i <= count; i++) {
        const sizeSelect = document.getElementById(`${productType}_size_${i}`);
        const colorSelect = document.getElementById(`${productType}_color_${i}`);

        if (sizeSelect && colorSelect) {
          const size = sizeSelect.value;
          const colorText = colorSelect.options[colorSelect.selectedIndex].text;

          const key = `${productName}|${size}|${colorText}`;

          if (!productCounts[key]) {
            productCounts[key] = {
              productName: productName,
              size: size,
              colorText: colorText,
              count: 0
            };
          }
          productCounts[key].count++;
        }
      }
    });

    let itemNumber = 1;
    Object.keys(productCounts).forEach(key => {
      const item = productCounts[key];
      const quantityText = item.count > 1 ? ` × ${item.count}枚` : '';

      customAttributes.push({
        key: `商品${itemNumber}`,
        value: `${item.productName} / サイズ:${item.size} / カラー:${item.colorText}${quantityText}`
      });

      itemNumber++;
    });

    const hasSpecialGift = selectedSetOption.dataset.hasSpecialGift === 'true';
    if (hasSpecialGift) {
      const giftType = document.querySelector('input[name="special_gift"]:checked');

      if (giftType && giftType.value === 'pgbra_nonwire') {
        const giftSize = document.getElementById('gift_pgbra_size');
        const giftColor = document.getElementById('gift_pgbra_color');

        if (giftSize && giftColor && giftSize.value && giftColor.value) {
          const colorText = giftColor.options[giftColor.selectedIndex].text;
          customAttributes.push({
            key: '特典',
            value: `PGブラ(ノンワイヤー) / サイズ:${giftSize.value} / カラー:${colorText}`
          });
        }
      } else if (giftType && giftType.value === 'glamorous') {
        customAttributes.push({
          key: '特典',
          value: 'グラマラス美神（バストクリーム）'
        });
      }
    }


    const orderDetails = generateOrderDetails();
    const checkoutNote = orderDetails + '\n【お客様メールアドレス】\n' + email;

    const lineItemsToAdd = [{
      variantId: variantId,
      quantity: 1,
      customAttributes: customAttributes
    }];

    const shippingAddress = {
      firstName: firstName,
      lastName: lastName,
      address1: address1,
      address2: address2,
      city: city,
      province: province,
      zip: zip,
      country: 'Japan',
      phone: phone
    };

    return client.checkout.addLineItems(cart.id, lineItemsToAdd)
      .then(function (checkout) {
        return client.checkout.updateEmail(checkout.id, email);
      })
      .then(function (checkout) {
        return client.checkout.updateShippingAddress(checkout.id, shippingAddress);
      })
      .then(function (checkout) {
        return client.checkout.updateAttributes(checkout.id, {
          note: checkoutNote
        });
      })
      .then(function (checkout) {
        // ブラウザバック用にデータ保持するため削除しない
        // sessionStorage.removeItem('orderFormData');

        let checkoutUrl = checkout.webUrl;
        const separator = checkoutUrl.includes('?') ? '&' : '?';
        checkoutUrl += `${separator}checkout[email]=${encodeURIComponent(email)}&discount=LB3QU42F`;

        window.location.href = checkoutUrl;
      })
      .catch(function (error) {
        showError('注文処理に失敗しました: ' + (error.message || 'もう一度お試しください'), true);
        submitBtn.disabled = !agreementCheckbox.checked;
        loadingEl.classList.remove('active');
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.toggle-btn');

    toggleButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const content = this.nextElementSibling;
        if (content && content.classList.contains('toggle-content')) {
          if (content.style.display === 'none' || content.style.display === '') {
            content.style.display = 'block';
            this.classList.add('active');
          } else {
            content.style.display = 'none';
            this.classList.remove('active');
          }
        }
      });
    });
  });

})();
